export default __webpack_public_path__ + "static/media/01-25-16.66297321.svg";